import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import { conversationsApi, type InboxListParams } from '../api/conversations-api';

import { conversationKeys } from './conversation-keys';

/** The inbox grows downwards and changes live, so it pages with "load more", not a URL cursor. */
export function inboxListQueryOptions(params: InboxListParams) {
  return infiniteQueryOptions({
    queryKey: conversationKeys.list(params),
    queryFn: ({ pageParam }) =>
      conversationsApi.list({ ...params, ...(pageParam ? { cursor: pageParam } : {}) }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });
}

export function useInboxList(params: InboxListParams, polling: boolean) {
  return useInfiniteQuery({
    ...inboxListQueryOptions(params),
    // Without the socket the list is kept fresh by polling (D-103 fallback for staff: 5 s).
    refetchInterval: polling ? 5_000 : false,
  });
}
